export enum LoginViews {
  'Login',
  'Password',
  'TemporaryPasscode',
  'AzureTemporaryPasscode',
  'Message'
}
